import { useParams } from 'react-router'

import type { TemplateRouteParams } from '../system/types'

/** Helper hook for retrieving the template ID from the query params.*/
export const useTemplateId = (): string => {
  const { templateId } = useParams<TemplateRouteParams>()

  if (!templateId) {
    throw new Error(`No template ID was found`)
  }

  return templateId
}
